import { AllocationDetailsFormFields } from "features/allocations/AllocationDetailsFormFields";
import { AllocationSetupFooter } from "features/allocations/setup/AllocationSetupFooter";
import {
  useAllocationRuleRetrieveSuspense,
  useAllocationRuleUpdate,
} from "gen/endpoints/allocation-rule/allocation-rule";
import { AllocationRuleEditDataRequest } from "gen/model/allocationRuleEditDataRequest";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  ContentBlock,
  ContentBlockBody,
  ContentBlockGroup,
} from "shared/components/content/ContentBlock";
import Form from "shared/components/form/Form";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { usePageWizard } from "shared/components/layout/PageWizard";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const AllocationSetupDetailsPage = () => {
  const { t } = useTranslation(["allocation"]);
  const { fundFamilyId, allocationRuleId } = useRequiredStringParams();
  const { mutateAsync: updateAllocationRule } = useAllocationRuleUpdate();
  const { navigateNext } = usePageWizard();
  const { data } = useAllocationRuleRetrieveSuspense(
    fundFamilyId,
    allocationRuleId,
  );

  const form = useForm<AllocationRuleEditDataRequest>({
    defaultValues: data,
  });

  return (
    <PageContent>
      <Form
        form={form}
        onSubmit={async (data) => {
          await updateAllocationRule({ fundFamilyId, allocationRuleId, data });
        }}
        onSuccess={navigateNext}
      >
        <PageHeader
          title={t("allocation:setup.details.heading")}
          workflowName={t("allocation:setup.superHeading")}
        />
        <PageBody>
          <ContentBlockGroup>
            <ContentBlock>
              <ContentBlockBody variant="form">
                <AllocationDetailsFormFields fundFamilyId={fundFamilyId} />
              </ContentBlockBody>
            </ContentBlock>
          </ContentBlockGroup>
          <AllocationSetupFooter />
        </PageBody>
      </Form>
    </PageContent>
  );
};
